export default __webpack_public_path__ + "static/media/logo.e4c8abf7.svg";